/* src/app/questionario-fgenergia/questionario-main.component.scss */
.titulo-pagina {
  margin-bottom: 30px !important;
}
.titulo-msg-sucesso {
  font-size: 110%;
  text-align: CENTER;
}
.texto-msg-sucesso {
  padding: 10px;
  text-align: LEFT;
  margin: 20px;
}
.box-token {
  border: 1px solid;
  padding: 15px;
  font-size: 120%;
  font-weight: 500;
  text-align: CENTER;
  margin: 25px;
}
.invalid-radio {
  margin-top: 0.75rem;
  font-size: 80%;
  color: #dc4140;
}
.ck_lgpd {
  padding-left: 15px;
  margin-top: 30px;
}
/*# sourceMappingURL=questionario-main.component.css.map */
